<template>
  <div
    v-if="!hideInitially || revealed"
    class="error-message d-flex justify-center"
    :class="{ 'error-message--inline': inline }"
    :data-test="dataTest"
  >
    <div ref="topMarker" />
    <div
      ref="container"
      :key="triggerCount"
      :class="{ shake: triggerCount }"
      class="error-message__container animated fast"
    >
      <headline-h3
        v-if="title"
        headline-class="error-headline ma-0"
        headline-seo
        :headline="title"
      />
      <div class="error-message__text">
        <slot />
      </div>
      <div
        v-if="code"
        class="error-message__code pt-3"
      >
        {{ $dict.get('online-Shop.Global-Labels.Error-Code') }}
        {{ code }}
      </div>
    </div>
    <div ref="bottomMarker" />
  </div>
</template>

<script>
// HeadlineH3 fails because of "Dependency cycle detected (import/no-cycle)"
// Solution might be: https://medium.com/visual-development/how-to-fix-nasty-circular-dependency-issues-once-and-for-all-in-javascript-typescript-a04c987cf0de
import { scrollToElement } from '@/utils/pageScrolling';

import HeadlineH3 from './headline-h3/HeadlineH3';

export default {
  name: 'ErrorMessage',
  components: {
    HeadlineH3,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    inline: {
      type: Boolean,
    },
    code: {
      type: String,
      default: null,
    },
    hideInitially: Boolean,
    dataTest: {
      type: String,
      default: null,
    },
    triggerOnCreation: Boolean,
    scrollTo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      revealed: false,
      triggerCount: 0,
    };
  },
  mounted() {
    if (this.triggerOnCreation) {
      this.trigger();
    }
  },
  methods: {
    async trigger() {
      // :key="triggerCount" wil re-insert the element in the dom when the
      // message gets triggered a second time. This is more reliable than
      // removing and re-adding the shake class.
      this.triggerCount += 1;
      this.revealed = true;
      if (IS_SSR) {
        return;
      }
      await this.$nextTick();
      if (!this.scrollTo) {
        const boundingClientRect = this.$refs.container.getBoundingClientRect();
        if (boundingClientRect.y <= 200) {
          scrollToElement(this.$refs.topMarker, {
            offset: 200,
          });
        } else if (boundingClientRect.bottom > document.documentElement.clientHeight - 200) {
          scrollToElement(this.$refs.bottomMarker);
        }
      } else {
        scrollToElement(document.querySelector(`#${this.scrollTo}`));
      }
    },
    hide() {
      this.revealed = false;
      this.shake = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './error-messages';
</style>
